// @flow
import { withProps } from 'react-recompose';
import PassportCheck from './PassportCheck.container';
import { StackActions } from '@react-navigation/native';
import Navigation from '../../../lib/navigation';

const withNavigationProps = () => ({
  goToConfirmPersonalInfo: (isEditing: boolean = false, isScanSuccessful?: boolean) =>
    Navigation.dispatch(StackActions.push('confirmPersonalInfo', { isManuallyEditing: isEditing, isScanSuccessful })),
});

export default withProps(withNavigationProps)(PassportCheck);
